import { render, staticRenderFns } from "./PettyCashForm.vue?vue&type=template&id=6b4f75ff"
import script from "./PettyCashForm.vue?vue&type=script&lang=js"
export * from "./PettyCashForm.vue?vue&type=script&lang=js"
import style0 from "./PettyCashForm.vue?vue&type=style&index=0&id=6b4f75ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports